<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <h2 class="mb-5">
                            {{$t('text.globals.adminTools')}}
                        </h2>

                        <h4><router-link to="/models" :title="$t('text.adminTools.models')">{{$t('text.adminTools.modelEditor')}}</router-link></h4>

                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script>
    import SidebarNavigation from "../components/SidebarNavigation";
    import axios from 'axios/index';

    export default {
        name: "AdminTools",
        components: {
            SidebarNavigation,
        },
        data() {
            return {
                breadcrumbItems: [
                    {
                        text: this.$t('text.adminTools.apm'),
                        href: '#/apm'
                    },
                    {
                        text: this.$t('text.adminTools.services'),
                        active: true
                    }
                ],

                models: [],
                testModelApiResponse: {"list":{"pagination":{"count":1,"hasMoreItems":false,"totalItems":1,"skipCount":0,"maxItems":100},"entries":[{"entry":{"author":"Administrator","name":"SuVpisnik","namespaceUri":"SUVpisnik","namespacePrefix":"SU","status":"DRAFT"}}]}}

            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AdminTools.vue